export { default } from "bullitttime-embermodelsgochips/serializers/statistic";
